import React, { useEffect, useState } from "react";
import axios from "../../utils/axiosConfig";
import "../styles/AdminFeesManager.css";

const API = "/api/fees";

const formatDate = (date) => {
  if (!date) return "";
  const d = new Date(date);
  const day = String(d.getDate()).padStart(2, "0");
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const year = d.getFullYear();
  return `${day}-${month}-${year}`;
};

const AdminFeesManager = () => {

  const [activeTab, setActiveTab] = useState("monthly");

  const [meta, setMeta] = useState({});
  const [monthly, setMonthly] = useState([]);
  const [schedule, setSchedule] = useState([]);
  const [rules, setRules] = useState([]);
  const [top, setTop] = useState([]);

  const [form, setForm] = useState({});
  const [editId, setEditId] = useState(null);

  const loadAll = async () => {
    const m = await axios.get(`${API}/meta`);
    const mo = await axios.get(`${API}/monthly`);
    const sc = await axios.get(`${API}/schedule`);
    const rl = await axios.get(`${API}/rules`);
    const tp = await axios.get(`${API}/top`);

    setMeta(m.data);
    setMonthly(mo.data);
    setSchedule(sc.data);
    setRules(rl.data);
    setTop(tp.data);
  };

  useEffect(() => {
    loadAll();
  }, []);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const resetForm = () => {
    setForm({});
    setEditId(null);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    let url = `${API}/${activeTab}`;

    if (editId) {
      await axios.put(`${url}/${editId}`, form);
    } else {
      await axios.post(url, form);
    }

    loadAll();
    resetForm();
  };

  const handleDelete = async (id) => {
    await axios.delete(`${API}/${activeTab}/${id}`);
    loadAll();
  };

  const handleEdit = (item) => {
    setForm(item);
    setEditId(item.id);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div className="admin-fees">

      <h2>Fees Management Panel</h2>

      {/* TABS */}
      <div className="tabs">
        {["meta", "top", "monthly", "schedule", "rules"].map(tab => (
          <button
            key={tab}
            className={activeTab === tab ? "active" : ""}
            onClick={() => {
              setActiveTab(tab);
              resetForm();
            }}
          >
            {tab.toUpperCase()}
          </button>
        ))}
      </div>

      {/* META */}
      {activeTab === "meta" && (
        <form
          onSubmit={async (e) => {
            e.preventDefault();
            await axios.put(`${API}/meta`, meta);
            alert("Updated");
          }}
          className="fees-form"
        >
          <input value={meta.feetitle || ""} onChange={(e) => setMeta({ ...meta, feetitle: e.target.value })} />
          <textarea value={meta.feerules || ""} onChange={(e) => setMeta({ ...meta, feerules: e.target.value })} />
          <input value={meta.paytitle || ""} onChange={(e) => setMeta({ ...meta, paytitle: e.target.value })} />
          <button className="btn-primary">Update</button>
        </form>
      )}

      {/* COMMON FORM */}
      {activeTab !== "meta" && (
        <form onSubmit={handleSubmit} className="fees-form">

          {activeTab === "top" && (
            <>
              <input name="label" placeholder="Label" value={form.label || ""} onChange={handleChange} required />
              <input name="amount" placeholder="Amount" value={form.amount || ""} onChange={handleChange} required />
            </>
          )}

          {activeTab === "monthly" && (
            <>
              <input name="class_name" placeholder="Class" value={form.class_name || ""} onChange={handleChange} required />
              <input name="amount" placeholder="Amount" value={form.amount || ""} onChange={handleChange} required />
            </>
          )}

          {activeTab === "schedule" && (
            <>
              <input name="month_name" placeholder="Month" value={form.month_name || ""} onChange={handleChange} required />
              <input type="date" onChange={(e) => setForm({ ...form, due_date: formatDate(e.target.value) })} />
            </>
          )}

          {activeTab === "rules" && (
            <input name="rule_text" placeholder="Rule" value={form.rule_text || ""} onChange={handleChange} required />
          )}

          <div className="btn-group">
            <button className="btn-success">{editId ? "Update" : "Add"}</button>
            <button type="button" onClick={resetForm} className="btn-warning">Reset</button>
          </div>
        </form>
      )}

      {/* TABLE */}
      <table className="admin-table">
        <thead>
          <tr>
            <th>Data</th>
            <th>Action</th>
          </tr>
        </thead>

        <tbody>
          {(activeTab === "top" ? top :
            activeTab === "monthly" ? monthly :
            activeTab === "schedule" ? schedule :
            rules
          ).map(item => (
            <tr key={item.id}>
              <td>
                {item.label || item.class_name || item.month_name || item.rule_text}
                {item.amount && ` - ₹${item.amount}`}
                {item.due_date && ` - ${item.due_date}`}
              </td>
              <td>
                <button className="btn-edit" onClick={() => handleEdit(item)}>Edit</button>
                <button className="btn-delete" onClick={() => handleDelete(item.id)}>Delete</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

    </div>
  );
};

export default AdminFeesManager;